import './styles.scss'
import React, { useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { InputText } from 'primereact/inputtext'
import { Skeleton } from 'primereact/skeleton'
import ROUTE_STRINGS from 'Utils/Constants/RouteStrings'
import SubscriptionTabItem from '../SubscriptionTabItem'
import GuidelinesButton from '../GuidelinesButton'
import { SUBSCRIPTION_TIERS } from '../../Utils'

const YourNewsSidebar = ({ reminders = [], selectedReminderId = null, showGuidelines = false, subscriptionType = 1, onSelectReminder, onEditReminder, onToggleActive, onDeleteReminder, onOpenGuidelines, searchPlaceholder = 'Search Your News', isLoading = false }) => {
  const history = useHistory()
  const [searchQuery, setSearchQuery] = useState('')

  const handleLockedTabClick = (tierType) => {
    const tierMap = {
      gold: SUBSCRIPTION_TIERS.GOLD,
      platinum: SUBSCRIPTION_TIERS.PLATINUM
    }

    const subscriptionId = tierMap[tierType] ?? null

    if (subscriptionId) {
      history.push({ pathname: ROUTE_STRINGS.subscription, state: { subscriptionId } })
    }
  }

  const visibleReminders = useMemo(() => {
    const q = (searchQuery || '').toLowerCase().trim()

    if (!q) return reminders

    return reminders.filter((r) => (r.title || '').toLowerCase().includes(q) || (r.prompt || '').toLowerCase().includes(q))
  }, [reminders, searchQuery])

  const isReminderEnabled = (reminder) => {
    const tierType = reminder?.tier_type ?? 'all'
    const isLocked = reminder?.is_subscription_locked === true

    if (isLocked) return false

    if (subscriptionType === SUBSCRIPTION_TIERS.REGULAR) {
      return tierType === 'all'
    }

    if (subscriptionType === SUBSCRIPTION_TIERS.GOLD) {
      return tierType === 'all' || tierType === 'gold'
    }

    if (subscriptionType === SUBSCRIPTION_TIERS.PLATINUM) {
      return true
    }

    return tierType === 'all'
  }

  return (
    <aside className="your-news-sidebar" data-testid="your-news-sidebar">
      <div className="your-news-sidebar__search">
        <span className="p-input-icon-left your-news-sidebar__search-wrap">
          <div className="search-input-div">
            <InputText value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} placeholder={searchPlaceholder} className="your-news-sidebar__search-input" data-testid="your-news-search" />
            {searchQuery ? (
              <button type="button" className="search-btn" onClick={() => setSearchQuery('')}>
                <i className="pi pi-times" />
              </button>
            ) : (
              <button type="button" className="search-btn" aria-controls="search-input">
                <i className="pi pi-search" />
              </button>
            )}
          </div>
        </span>
      </div>

      <div className="your-news-sidebar__list">
        <>
          {isLoading && (
            <div className="your-news-sidebar__skeleton-list">
              {Array.from({ length: 10 }).map((_, index) => (
                <div key={index} className="your-news-sidebar__skeleton-item">
                  <Skeleton width="34px" height="34px" className="your-news-sidebar__skeleton-edit-icon" />
                  <div className="your-news-sidebar__skeleton-text">
                    <Skeleton width="100%" height="34px" className="custom-skelton" />
                  </div>
                  <Skeleton width="34px" height="34px" className="your-news-sidebar__skeleton-icon" />
                </div>
              ))}
            </div>
          )}

          {!isLoading && visibleReminders.length === 0 && <p className="your-news-sidebar__empty">No news tabs yet.</p>}

          {!isLoading &&
            visibleReminders.length > 0 &&
            visibleReminders.map((reminder, index) => {
              const isEnabled = isReminderEnabled(reminder)
              const isLocked = !isEnabled || reminder?.is_subscription_locked === true
              const insertGuidelinesBeforeLast = index === Math.max(0, visibleReminders.length - 1)

              return (
                <React.Fragment key={reminder.id}>
                  <SubscriptionTabItem reminder={reminder} id={reminder.id} title={reminder.title} unreadCount={reminder.unread_count ?? 0} isActive={selectedReminderId === reminder.id} isSubscriptionLocked={isLocked} isGlobalSlot={reminder.tier_type === 'all'} tierType={reminder.tier_type ?? 'all'} canEdit={reminder.can_edit_title !== false && !isLocked} onSelect={isLocked ? undefined : onSelectReminder} onEdit={onEditReminder} onLockedClick={handleLockedTabClick} />
                  {insertGuidelinesBeforeLast && <GuidelinesButton onOpenGuidelines={onOpenGuidelines} isActive={showGuidelines} />}
                </React.Fragment>
              )
            })}
        </>
      </div>
    </aside>
  )
}

export default YourNewsSidebar
